export * from './TVISpeed';
